import CheckoutPrice from 'domains/customer-checkout/molecules/price'
import PreOrderBadge from 'domains/customer-checkout/molecules/shipment-item/pre-order-badge'
import PropTypes from 'prop-types'

/**
 *
 * @param {item} item - Shipment Itemthat represents a Product in a Checkout Shipment
 */
const CustomerCheckoutShipmentItem = ({ item }) => {

  const { product, product_dimension, inventory } = item
  const itemQuantityWeight                        = [
    item.quantity,
    'Barang',
    `(${item.weight} gr)`
  ].join(' ')

  return (
    <div className='d-flex'>
      { /* Product Image */ }
      <img
        className='align-self-center mr-3'
        width='30%'
        src={ product.image }
        alt={ product.name }
      />

      { /* Product Details */ }
      <div className='flex-fill'>

        <div className='d-flex justify-content-end'>
          <PreOrderBadge days={ inventory.preorder_days } />
        </div>

        <div className='small font-weight-bold text-uppercase mb-2'>
          { product.brand }
        </div>

        <div className='small mb-1'>
          { product.name }
        </div>

        {
          product_dimension && product_dimension.size ?
            <div  className='small mb-1'>
              { 'Size: ' } { product_dimension.size }
            </div>
            : null
        }

        <div  className='small text-gray-light mb-1' >
          { itemQuantityWeight }
        </div>

        <div className='small text-right'>
          <CheckoutPrice price={ product.selling_price } />
        </div>
      </div>

    </div>
  )
}

CustomerCheckoutShipmentItem.propTypes = {
  item: PropTypes.shape({
    quantity : PropTypes.number,
    weight   : PropTypes.number,
    product  : PropTypes.shape({
      brand         : PropTypes.string.isRequired,
      image         : PropTypes.string.isRequired,
      sku           : PropTypes.string,
      name          : PropTypes.string,
      price         : PropTypes.number,
      selling_price : PropTypes.number,
      image_url     : PropTypes.string
    }),
    product_dimension: PropTypes.shape({
      size         : PropTypes.string,
      measurements : PropTypes.array
    }),
    inventory: PropTypes.shape({
      preorder_days: PropTypes.number
    })
  })
}

CustomerCheckoutShipmentItem.defaultProps = {
  item: {
    product_id     : -1,
    brand          : 'Default Brand',
    name           : 'Default Shipment Item Name',
    size           : '88',
    pre_order_days : -1,
    sku            : 'Default Shipment Item SKU',
    price          : 888888,
    quantity       : -1,
    weight         : -1,
    image_url      : ''
  }
}

export default CustomerCheckoutShipmentItem